export default __webpack_public_path__ + "static/media/H1005.c8190e84.mp3";